import * as TogglePrimitive from '@radix-ui/react-toggle';
import * as React from 'react';

import { VariantProps, cn, tv } from './cn';

const toggleVariants = tv({
  base: 'inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-bg-secondary transition-colors hover:bg-bg-quaternary hover:text-text-tertiary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-accent-quaternary focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-bg-accent-strong-secondary data-[state=on]:text-text-primary',
  variants: {
    variant: {
      default: 'bg-transparent',
      outline:
        'border border-border-primary bg-transparent hover:bg-bg-accent-strong-secondary hover:text-text-primary',
    },
    size: {
      default: 'h-10 px-3',
      sm: 'h-9 px-2.5',
      lg: 'h-11 px-5',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'default',
  },
});

const Toggle = React.forwardRef<
  React.ElementRef<typeof TogglePrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof TogglePrimitive.Root> &
    VariantProps<typeof toggleVariants>
>(({ className, variant, size, ...props }, ref) => (
  <TogglePrimitive.Root
    ref={ref}
    className={cn(toggleVariants({ variant, size, className }))}
    {...props}
  />
));

Toggle.displayName = TogglePrimitive.Root.displayName;

export { Toggle, toggleVariants };
